import styled from 'styled-components/macro';

export const InfoContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;
